export default __webpack_public_path__ + "static/media/result.40421fef.gif";